import { ModuleHeader, ModuleTable } from "../components/index";
import { PageContextDeliveryProvider } from "../context/delivery-provider";
import {
  ModalTrackingView,
  ContextModalTrackingViewProvider,
} from "@/module/modal-tracking-view";

export const LayoutPageDelivery = () => (
  <>
    <ContextModalTrackingViewProvider>
      <PageContextDeliveryProvider>
        <ModuleHeader />
        <ModuleTable />
        <ModalTrackingView />
      </PageContextDeliveryProvider>
    </ContextModalTrackingViewProvider>
  </>
);
